import { render, staticRenderFns } from "./MoreColumn.vue?vue&type=template&id=81396bc2&"
import script from "./MoreColumn.vue?vue&type=script&lang=js&"
export * from "./MoreColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports